import type { GQL_ID } from '@@partner:types:graphql'
import type { BannerType } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

import { SHORTCUT_BANNER_TYPE_FIELDS } from '@@partner:graphql/shortcuts'

export interface BannerTypeInfoInput {
  id?: GQL_ID
  label?: string
  code?: string
}

export interface SaveBannerType {
  bannerTypeInfo: BannerType
}
export interface SaveBannerTypeVariables {
  bannerTypeInfo: BannerTypeInfoInput
}

export const GQL_MUTATION_SAVE_BANNER_TYPE = gql`
  mutation($newData: BannerTypeInfoInput!, $upsert: Boolean!) {
    bannerTypeInfo: updateBannerTypeInfo(newData: $newData, upsert: $upsert) {
      ${SHORTCUT_BANNER_TYPE_FIELDS}
    }
  }
`

export const useMutateSaveBannerType = () =>
  useMutation<SaveBannerType, SaveBannerTypeVariables>(
    GQL_MUTATION_SAVE_BANNER_TYPE
  )
